(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-testimonials')) {
    class VideoTestimonials extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.vt__card'));
        this.visible = new Set();
        this.isOpen = false;

        const tpl = this.querySelector('template');
        if (tpl) {
          this.modal = tpl.content.firstElementChild.cloneNode(true);
          document.body.appendChild(this.modal);
          this.modalVideo = this.modal.querySelector('.vt-modal__video');
          this.closeBtn = this.modal.querySelector('.vt-modal__close');
          const overlay = this.style.getPropertyValue('--vt-overlay');
          if (overlay) this.modal.style.setProperty('--vt-overlay', overlay);
          this.modal.querySelectorAll('[data-close]').forEach((el) =>
            el.addEventListener('click', () => this.close())
          );
        }

        this.onKey = (e) => { if (e.key === 'Escape') this.close(); };

        this.cards.forEach((card) => {
          const v = card.querySelector('video');
          v.muted = true;
          v.defaultMuted = true;
          card.userPaused = false;

          v.addEventListener('play', () => card.classList.remove('is-paused'));
          v.addEventListener('pause', () => card.classList.add('is-paused'));

          card.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-action]');
            if (!btn) return;
            const action = btn.dataset.action;

            if (action === 'toggle-play') {
              if (v.paused) {
                card.userPaused = false;
                v.play().catch(() => {});
              } else {
                card.userPaused = true;
                v.pause();
              }
            }

            if (action === 'toggle-mute') {
              v.muted = !v.muted;
              card.classList.toggle('is-muted', v.muted);
              if (!v.muted) {
                // only one video with sound at a time
                this.cards.forEach((other) => {
                  if (other !== card) {
                    const ov = other.querySelector('video');
                    ov.muted = true;
                    other.classList.add('is-muted');
                  }
                });
                if (v.paused && !card.userPaused) v.play().catch(() => {});
              }
            }

            if (action === 'expand') this.open(card);
          });
        });

        // autoplay when visible, pause when out of view
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const card = entry.target;
              const v = card.querySelector('video');
              if (entry.isIntersecting) {
                this.visible.add(card);
                if (!card.userPaused && !this.isOpen) v.play().catch(() => {});
              } else {
                this.visible.delete(card);
                v.pause();
              }
            });
          },
          { threshold: 0.25 }
        );
        this.cards.forEach((card) => this.observer.observe(card));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('keydown', this.onKey);
        document.documentElement.style.overflow = '';
        if (this.modal) this.modal.remove();
      }

      open(card) {
        if (!this.modal) return;
        this.isOpen = true;
        this.lastCard = card;
        this.cards.forEach((c) => c.querySelector('video').pause());

        this.modalVideo.src = card.dataset.full;
        this.modalVideo.poster = card.dataset.poster || '';
        this.modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKey);

        this.modalVideo.play().catch(() => {});
        this.closeBtn.focus({ preventScroll: true });
      }

      close() {
        if (!this.modal || !this.isOpen) return;
        this.isOpen = false;
        this.modalVideo.pause();
        this.modalVideo.removeAttribute('src');
        this.modalVideo.load();
        this.modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.onKey);

        this.cards.forEach((card) => {
          if (this.visible.has(card) && !card.userPaused) {
            card.querySelector('video').play().catch(() => {});
          }
        });
        if (this.lastCard) {
          const b = this.lastCard.querySelector('[data-action="expand"]');
          if (b) b.focus({ preventScroll: true });
        }
      }
    }
    customElements.define('video-testimonials', VideoTestimonials);
  }

  } catch(e) { console.error(e); }
})();
})();
